/**
 * Gets the html code for the rendering of comments.
 *
 * @author Marcel Werk
 * @copyright 2001-2024 WoltLab GmbH
 * @license GNU Lesser General Public License <http://opensource.org/licenses/lgpl-license.php>
 * @since 6.1
 */
define('WoltLabSuite/Core/Api/Comments/RenderComments',["require", "exports", "WoltLabSuite/Core/Ajax/Backend", "../Result"], function (require, exports, Backend_1, Result_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.renderComments = renderComments;
    async function renderComments(objectTypeId, objectId, lastCommentTime = 0) {
        const url = new URL(`${window.WSC_RPC_API_URL}core/comments/render`);
        url.searchParams.set("objectTypeID", objectTypeId.toString());
        url.searchParams.set("objectID", objectId.toString());
        url.searchParams.set("lastCommentTime", lastCommentTime.toString());
        let response;
        try {
            response = (await (0, Backend_1.prepareRequest)(url).get().fetchAsJson());
        }
        catch (e) {
            return (0, Result_1.apiResultFromError)(e);
        }
        return (0, Result_1.apiResultFromValue)(response);
    }
});

